import { useEffect, useRef, useState } from "react";
import Card from "./CartaParejas";

import '../../../../../../../theme/MemoriaParejas.css';
import { useJuegos } from "../../../../../../../repositorio/controlador/useJuegos";

interface Props{
    cantidad: number;
    visible: boolean;
    estado?: number;
    onLoad?: () => void;
    onWin: (intentos: number) => void;
}

const TableroParejas = (props: Props) => {

    const {cantidad, visible, onLoad, onWin} = props;

    const { getRutasImagenesParejas } = useJuegos();

    const [estado , setEstado] = useState<number>(props.estado ?? 0);
    const [intentos, setIntentos] = useState<number>(0);
    
    const [clickActivo, setClickActivo] = useState<boolean>(false);
    
    const [cartas, setCartas] = useState<string[]>([]);
    const [indiceCarta, setIndiceCarta] = useState<number>(-1);
    const [cartasResueltas, setCartasResueltas] = useState<number>(0);
    const [estadoCartas, setEstadoCartas] = useState<boolean[]>(Array(cantidad * 2).fill(false));
    
    const [imagenesListas, setImagenesListas] = useState<number>(0);
    // evita avisar "listo" mas de una vez por ronda de cartas
    const avisoListoRef = useRef<boolean>(false);
    const inter = useRef<ReturnType<typeof setInterval> | null>(null);


    //-- functional

    const ConstruirCartas = async () => {
        let imagenes = await getRutasImagenesParejas(cantidad/2);

        let nuevasCartas: string[] = []
        imagenes.concat(imagenes).forEach((imagen, indice) => {
            nuevasCartas.push(imagen);
        });

        nuevasCartas.sort(() => (Math.random() - 0.5));

        avisoListoRef.current = false;
        setImagenesListas(0);
        setCartas(nuevasCartas);
    }

    // Se llama cuando cada carta termina de cargar su imagen (exito o error).
    const ActulizarCarga = () => {
        setImagenesListas((prev) => prev + 1);
    }

    //-- GameLogic

    const ManejarClickCarta = (indice: number) => {
        if(clickActivo && !estadoCartas[indice]){
            let nuevoEstadoCartas = [...estadoCartas];
            nuevoEstadoCartas[indice] = true;

            if(indiceCarta >= 0){
                setClickActivo(false);

                if(cartas[indiceCarta] !== cartas[indice]){
                    setIntentos(intentos + 1);

                    setTimeout(() => {
                        let nuevoEstadoCartas = [...estadoCartas];
                        let backupIndiceCarta = indiceCarta;

                        nuevoEstadoCartas[indice] = false;
                        nuevoEstadoCartas[backupIndiceCarta] = false;

                        setEstadoCartas(nuevoEstadoCartas);
                        setClickActivo(true);
                    }, 900);

                }else{
                    setClickActivo(true);
                    setCartasResueltas(cartasResueltas + 2);

                    if(cartasResueltas + 2 >= cartas.length){
                        onWin(intentos);
                    }
                }

                setIndiceCarta(-1);
            }else{
                setIndiceCarta(indice);
            }
            setEstadoCartas(nuevoEstadoCartas);
        }
    }



    //-- effects

    useEffect(() => {
        if (estado !== 3) return;

        ConstruirCartas();

        // Ultimo recurso: si algo se rompe del todo (red caida, error de Storage)
        // igual se deja avanzar el juego en vez de dejarlo colgado para siempre.
        // No es la via normal: en condiciones normales el aviso de "listo" de
        // abajo (cuando todas las imagenes ya cargaron) dispara mucho antes.
        const timeoutId = setTimeout(() => {
            if (!avisoListoRef.current) {
                console.warn("Carga de imagenes de parejas no termino a tiempo, se avanza igual");
                avisoListoRef.current = true;
                onLoad();
            }
        }, 15000);

        return () => clearTimeout(timeoutId);
    }, [cantidad, estado]);

    // Avisa al padre que el tablero esta listo SOLO cuando todas las imagenes
    // de este nivel terminaron de cargar (exito o error) en el navegador.
    // Antes se avisaba apenas se conseguian las rutas de las imagenes (o a los
    // 3 seg a ciegas), sin esperar la descarga real: con red lenta la fase de
    // "memoriza las cartas" corria con el tablero vacio y el jugador nunca
    // alcanzaba a ver las cartas.
    useEffect(() => {
        if (avisoListoRef.current) return;
        if (cartas.length > 0 && imagenesListas >= cartas.length) {
            avisoListoRef.current = true;
            onLoad();
        }
    }, [imagenesListas, cartas]);


    useEffect(() => setEstado(props.estado), [props.estado]);

    useEffect(() => {
        switch(estado){
            case 0:
                setEstadoCartas(Array(cantidad).fill(false));
                setCartasResueltas(0);
                setIntentos(0);
                break;
            case 1:
                setClickActivo(false);
                setEstadoCartas(Array(cantidad).fill(true));
                break;
            case 2:
                setEstadoCartas(Array(cantidad).fill(false));
                setTimeout(
                    () => setClickActivo(true),
                    800
                )
                break;
            case 3:
                setEstadoCartas(Array(cantidad).fill(false));
                break;
            default:
                break;
        }
    }, [estado]);

    return (
        <div className={`cubrir tableroContenedor${visible? "": " desaparecer"}`}>
            <div className={`memory-game grid${cartas.length}`} >
                {cartas.map((carta, indice) => {

                    return (<Card
                    key={indice}
                    imagen={carta}
                    volteada={estadoCartas[indice]}
                    onClick={() => ManejarClickCarta(indice)}
                    onLoad={ActulizarCarga}
                    index={indice%4 + 1}
                    />);
                })}
            </div>

            <div className="flexLayout bottomInfoContainer">
                INTENTOS: {intentos}
            </div>
        </div>
    );
}

export default TableroParejas;
